import { render, staticRenderFns } from "./GeneralInfos.vue?vue&type=template&id=027773a4&"
import script from "./GeneralInfos.vue?vue&type=script&lang=js&"
export * from "./GeneralInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GeneralInfos.vue"
export default component.exports